var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata"},[_c('div',{staticClass:"nodata-box"},[_c('p',[_c('i',{staticClass:"iconfont icon-zanwushuju"})]),_c('p',[_vm._v("暂无数据")])])])
}]

export { render, staticRenderFns }